import { getToken } from '@/utils/auth';
import axios from 'axios';
import store from '../store';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 60000 // 请求超时时间
  // dataType: 'jsonp'
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    const token = getToken() || store.getters.token;
    if (window.location.href.indexOf('certification') > -1) {
    }
    if (token) {
      config.headers['Authorization'] = token; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    // Do something with request error
    Promise.reject(error);
  }
);
function handleResponseCode(res) {
  return Promise.reject(res);
}
// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res && res.code < 200 && res.code >= 300) {
      return handleResponseCode(res);
    } else {
      return res;
    }
  },
  (error) => {
    if (error.response && error.response.data) {
      const res = error.response.data;
      return handleResponseCode(res);
    }
    return Promise.reject(error.response);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js